import type { Org, OrgMember } from "../lib/orgs";

/** ══ 조직 견본 — 패턴 페이지(`#/patterns`) 전용 ══
 *  한 사람이 조직마다 다른 역할로 든 모양(OWNER · USER · GUEST · 멤버 아님)을 일부러 섞었다. */
const base = { createdBy: "admin", createdAt: "2026-10-31T00:00:00Z" };

export const PAT_ORGS: Org[] = [
  { ...base, id: "o-irolab", name: "irolab-co", memberCount: 4, myRole: "OWNER", projects: [{ id: "in.b3x.app", name: "b3x-in" }, { id: "ops", name: "운영" }], gitConnection: { id: "g1", label: "GitHub irolab-co", provider: "github" } }, // copy-ignore: 견본 자료
  { ...base, id: "o-platform", name: "platform-team", memberCount: 7, myRole: "USER", projects: [{ id: "p-api", name: "플랫폼 API" }], gitConnection: { id: "g2", label: "사내 Gitea", provider: "gitea" } }, // copy-ignore: 견본 자료
  { ...base, id: "o-partner", name: "partner-acme", memberCount: 2, myRole: "GUEST", projects: [{ id: "p-acme", name: "acme 납품" }], gitConnection: null }, // copy-ignore: 견본 자료
  { ...base, id: "o-new", name: "design-lab", memberCount: 0, myRole: null, projects: [], gitConnection: null },
];

export const PAT_ORG_MEMBERS: OrgMember[] = [
  { userId: "u1", username: "kim", displayName: "김하늘", role: "OWNER", addedAt: "2026-10-31T00:00:00Z" }, // copy-ignore: 견본 자료
  { userId: "u2", username: "lee", displayName: null, role: "USER", addedAt: "2026-10-31T00:00:00Z" },
  { userId: "u3", username: "park", displayName: "박서준", role: "USER", addedAt: "2026-10-31T00:00:00Z" }, // copy-ignore: 견본 자료
  { userId: "u4", username: "acme-pm", displayName: null, role: "GUEST", addedAt: "2026-10-31T00:00:00Z" },
];

export const PAT_ORG_PROJECTS = [
  { id: "in.b3x.app", name: "b3x-in", orgId: "o-irolab" },
  { id: "ops", name: "운영", orgId: "o-irolab" }, // copy-ignore: 견본 자료
  { id: "p-api", name: "플랫폼 API", orgId: "o-platform" }, // copy-ignore: 견본 자료
  { id: "p-free", name: "사내 위키", orgId: null }, // copy-ignore: 견본 자료
];

export const PAT_ORG_CONNS = [
  { id: "g1", label: "GitHub irolab-co", provider: "github" },
  { id: "g2", label: "사내 Gitea", provider: "gitea" }, // copy-ignore: 견본 자료
];
